import React from "react";
import Icon from "components/AppIcon";


const FirstThreeSteps = ({ steps }) => {
  return (
    <section className="bg-white rounded-2xl border border-[rgba(40,59,163,0.10)] shadow-sm p-6 md:p-8 lg:p-10">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "rgba(40,59,163,0.08)" }}>
          <Icon name="ListChecks" size={22} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-widest" style={{ color: "var(--color-accent)", fontFamily: "var(--font-caption)" }}>Section 6</p>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>Your First Three Steps</h2>
        </div>
      </div>
      <p className="text-sm md:text-base mb-6" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}>
        Do these three things this week. Nothing else. Momentum begins with a single, concrete action.
      </p>
      <div className="flex flex-col gap-4 mb-8">
        {steps?.map((step, idx) => (
          <div key={idx} className="flex items-start gap-4 p-4 md:p-5 rounded-xl border" style={{ backgroundColor: "var(--color-surface)", borderColor: "var(--color-border)" }}>
            <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-lg font-bold" style={{ backgroundColor: "var(--color-primary)", color: "#fff", fontFamily: "var(--font-data)" }}>
              {idx + 1}
            </div>
            <div className="min-w-0">
              <h3 className="text-sm md:text-base font-bold mb-1" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)", fontWeight: 700 }}>{step?.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}>{step?.description}</p>
              {step?.timeEstimate && (
                <div className="flex items-center gap-1.5 mt-2">
                  <Icon name="Clock" size={13} color="var(--color-accent)" strokeWidth={2} />
                  <span className="text-xs font-medium" style={{ color: "var(--color-accent)", fontFamily: "var(--font-caption)" }}>{step?.timeEstimate}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
     
    </section>
  );
};

export default FirstThreeSteps;